import { MapPin } from "lucide-react";
import { Reveal, Label } from "./Reveal";
import { CONTACT, CLIENTS } from "../data";

export default function Coverage() {
  return (
    <section
      id="coverage"
      data-testid="coverage-section"
      className="bg-surface py-24 lg:py-32 border-b border-border"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <Label>Service Area</Label>
            <h2 className="font-display uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[0.95] text-white">
              South East<br />Queensland.
            </h2>
            <p className="mt-8 max-w-md text-zinc-400 font-light leading-relaxed">
              Headquartered in Brisbane, servicing commercial and industrial
              facilities from the CBD to the Sunshine Coast.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-border border border-border">
            {CONTACT.regions.map((r, i) => (
              <Reveal key={r} delay={i * 0.08} className="bg-obsidian">
                <div className="p-8 h-full flex flex-col justify-between min-h-[180px]">
                  <MapPin className="text-acid" size={22} />
                  <div>
                    <div className="font-display uppercase text-xl text-white tracking-tight">
                      {r}
                    </div>
                    <div className="mt-1 text-xs uppercase tracking-[0.2em] text-zinc-500">
                      Active region
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-8 border border-border p-8">
            <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-5">
              Facility types we service
            </div>
            <div className="flex flex-wrap gap-2">
              {CLIENTS.map((c) => (
                <span
                  key={c}
                  className="text-[11px] uppercase tracking-[0.15em] border border-border text-zinc-300 px-4 py-2 hover:border-acid hover:text-acid transition-colors"
                >
                  {c}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
